import React, { useContext, useRef, useState,useEffect } from 'react';
import { FaFilePdf, FaPlus } from 'react-icons/fa';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { _imagesURL, AddClinicalStudies, AddSurvay } from '../../../constants/API';
import Cropper from "../../../../src/cropper/components/CroppersWizard.tsx";
import { Language } from '../../../App';
import { toast } from 'react-toastify';
import axios from 'axios';
import { RiImageAddLine, RiSparkling2Fill, RiFileList3Line, RiUploadCloud2Line } from 'react-icons/ri';
import { IoCloseSharp } from 'react-icons/io5';
import PostImageModal from './PostImageModal';
import ImagePreviewModal from '../../common/ImagePreviewModal';
import { useCheckSubscriptionPermission } from '../../../hooks/useCheckSubscriptionPermission';
import { releaseAgendaScrollLock } from '../../../utils/agendaUtils';
import {
  categorizeFiles,
  dispatchFilesToInput,
  readFilesAsDataUrls,
  createDropzoneHandlers,
} from '../../../utils/fileDropUtils';
import './formTheme.css';

function ClinicalStudyTab({ onHide, setProgress, handleApiCall, refetch, initialDroppedFiles }) {
  const { lang } = useContext(Language);
  const checkPermission = useCheckSubscriptionPermission('create_clinical_study');
  const childRef = useRef(null);

  const SplashData = JSON.parse(localStorage.getItem("SplashData") || "{}");
  const sub_category = SplashData?.home?.subcategories || [];
  const { data: userToken } = JSON.parse(localStorage.getItem("SignupData") || "{}");
  const [pdf, setPdf] = useState("");
  const [imagesUrl, setImagesUrl] = useState([]);
  const [type, setType] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const [qsModal, setQsModal] = useState(false);
  const [showProgress, setShowProgress] = useState(false);
  const [qs, setQs] = useState([{ question: "", answers: ["", "", ""] }]);
  const [savedQs, setSavedQs] = useState([]);
  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const toggleImagePreview = () => setIsImagePreviewOpen(!isImagePreviewOpen);
  const handleImageClick = (img) => {
    setPreviewImage(img);
    toggleImagePreview();
  };
  const [coverImg, setCoverImg] = useState([]);
  const [imgArr, setImgArr] = useState([]);
  const [cropperOpen, setCropperOpen] = useState(false);
  const maxNumber = 6;
  const [ar, setAR] = useState(1);
  const [maxARatio, setMaxAR] = React.useState(undefined);
  const [minARatio, setMinAR] = React.useState(undefined);
  const [resizable, setResizable] = useState(true);
  const [hasSettings, setHasSettings] = useState(true);
  const [updateCoordinatesCheck, setUpdateCoordinatesCheck] = useState(false);
  const [fileUploadRefs, setFileUploadRefs] = React.useState({});
  const [numberOfImages, setNumberOfImages] = React.useState(maxNumber);
  const [height, setHeight] = React.useState(undefined);
  const [width, setWidth] = React.useState(undefined);
  const [top, setTop] = React.useState(undefined);
  const [left, setLeft] = React.useState(undefined);
  const [formData, setFormData] = useState({
    title: '',
    category: '',
    description: '',
    file: null,
  });
  const [isTruncated, setIsTruncated] = useState(true);
  const toggleTruncate = () => {
    setIsTruncated(!isTruncated);
  };

  const getImagesUrl = (url) => {
    setImagesUrl(url);
  };
  const handleClose = () => {
    setCropperOpen(false);
  };
  const onImageRemove = (index) => {
    const updatedImages = (Array.isArray(imgArr) ? [...imgArr] : Object.values(imgArr || {})).filter((_, i) => i !== index);

    setCoverImg(updatedImages);
    setImgArr(updatedImages);

    const newCount = updatedImages.length < maxNumber ? updatedImages.length + 1 : updatedImages.length;
    setNumberOfImages(newCount);

    // Clear value on existing file inputs so the same image file can be picked again
    Object.values(fileUploadRefs || {}).forEach((r) => {
      if (r?.current) {
        r.current.value = '';
      }
    });

    if (updatedImages.length === 0) {
      setHasSettings(true);
      setAR(undefined);
      setMinAR(undefined);
      setMaxAR(undefined);
      setWidth(500);
      setHeight(500);
      setTop(0);
      setLeft(0);
      setCropperOpen(false);
    }
  };

  const [isImageDragging, setIsImageDragging] = useState(false);
  const [isPdfDragging, setIsPdfDragging] = useState(false);

  const processDroppedFiles = (files) => {
    if (!files || files.length === 0) return;
    const { pdfFiles, imageFiles } = categorizeFiles(files);

    if (pdfFiles.length > 0) {
      setPdf(pdfFiles[0]);
    }

    if (imageFiles.length > 0) {
      const currentList = Array.isArray(imgArr) ? imgArr : Object.values(imgArr || {});
      const remainingSlots = maxNumber - currentList.length;
      if (remainingSlots <= 0) {
        toast.warning(`You can only upload up to ${maxNumber} images.`);
        return;
      }
      const filesToProcess = imageFiles.slice(0, remainingSlots);

      const currentIndex = Math.max(0, (Number(numberOfImages) || 1) - 1);
      const inputEl =
        fileUploadRefs?.[currentIndex]?.current ||
        Object.values(fileUploadRefs || {}).find((r) => r?.current)?.current;

      const dispatched = dispatchFilesToInput(inputEl, filesToProcess);
      if (!dispatched) {
        readFilesAsDataUrls(filesToProcess)
          .then((dataUrls) => {
            setImgArr((prev) => [...(Array.isArray(prev) ? prev : Object.values(prev || {})), ...dataUrls]);
            setCoverImg((prev) => [...(Array.isArray(prev) ? prev : Object.values(prev || {})), ...dataUrls]);
          })
          .catch((err) => {
            console.error("Error reading dropped clinical images:", err);
          });
      }
    }
  };

  useEffect(() => {
    if (initialDroppedFiles && initialDroppedFiles.length > 0) {
      const timer = setTimeout(() => {
        processDroppedFiles(initialDroppedFiles);
      }, 120);
      return () => clearTimeout(timer);
    }
  }, [initialDroppedFiles]);

  const imageDropHandlers = createDropzoneHandlers(processDroppedFiles, setIsImageDragging);
  const pdfDropHandlers = createDropzoneHandlers(
    (files) => {
      const { pdfFiles, imageFiles } = categorizeFiles(files);
      if (pdfFiles.length > 0) {
        setPdf(pdfFiles[0]);
      } else if (imageFiles.length > 0) {
        processDroppedFiles(files);
      }
    },
    setIsPdfDragging
  );

  const handleImageUploadClick = () => {
    const currentList = Array.isArray(imgArr) ? imgArr : Object.values(imgArr || {});
    if (currentList.length >= maxNumber) {
      toast.warning(`You can only upload up to ${maxNumber} images.`);
      return;
    }
    const currentIndex = numberOfImages - 1;
    let inputEl = fileUploadRefs?.[currentIndex]?.current;
    if (!inputEl) {
      inputEl = Object.values(fileUploadRefs || {}).find((r) => r?.current)?.current;
    }
    if (inputEl) {
      inputEl.value = '';
      inputEl.click();
    }
  };
  const handleSubmit = async () => {
    setShowProgress(true);
    releaseAgendaScrollLock(true);
    onHide();
    const data = {
      title: formData.title,
      type: "clinical-image",
      category: "3",
      subcategory: formData.category,
      caption: formData.description,
      mediaBase64: imgArr,
    };
    try {
      const res = await axios.post(AddClinicalStudies, data, {
        onUploadProgress: (progressData) => {
          setProgress(Math.round((100 * progressData.loaded) / progressData.total));
        },
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userToken?.token}`,
        },
      });

      if (res.data.status) {
        setShowProgress(false);
        handleSurvay(res.data.post.id, qs);
        releaseAgendaScrollLock(true);
        onHide();
        return res;
      } else {
        setShowProgress(false);
        toast.error(res.data.action);
      }
    } catch (error) {
      setShowProgress(false);
      console.error(error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  const handleSurvay = (post_id, questionsData) => {
    if (!questionsData || questionsData.length === 0) {
      return;
    }
    const questions = [];
    const option1 = [];
    const option2 = [];
    const option3 = [];
    questionsData.forEach((item) => {
      questions.push(item.question);
      option1.push(item.answers[0]);
      option2.push(item.answers[1]);
      option3.push(item.answers[2]);
    });
    const data = { pdf, questions, option1, option2, option3, post_id };
    axios
      .post(AddSurvay, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userToken?.token}`,
        },
      })
      .then((res) => {
        if (res.data.status) {
          refetch();
        } else {
          toast.error(res.data.action);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const _handleSubmit = async (e) => {
    e.preventDefault();
    if (!checkPermission()) return;
    await handleApiCall(() => handleSubmit(), { type: "clinical-study" });
  };

  const truncatedName = pdf?.name?.length > 45 ? `${pdf.name.slice(0, 45)}...` : pdf?.name;
  const surveyQuestionsCount = qs.filter((q) => q.question.trim()).length;

  return (
    <>
      <div className="pf-form-body">
        <form onSubmit={_handleSubmit} className="pf-form-flex-wrapper pf-study-form">
          <div className="pf-form-content">
            {/* AI Banner */}
            <div className="pf-ai-banner">
              <div className="pf-ai-banner-left">
                <RiSparkling2Fill className="pf-ai-banner-sparkle" size={15} />
                <span>Peer-Reviewed Clinical Study & Case Report</span>
              </div>
              <span className="pf-ai-banner-tag">Clinical Trial Registry</span>
            </div>

            {/* Title & Category Grid */}
            <div className="pf-grid-2">
            <div className="pf-field">
              <div className="pf-label">
                <span className="pf-label-text">{lang?.title || "Study Title"}</span>
              </div>
              <input
                type="text"
                className="pf-input"
                placeholder={lang?.clinical_study_title || "e.g., Efficacy of Novel Corneal Crosslinking Protocol"}
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              />
            </div>

            <div className="pf-field">
              <div className="pf-label">
                <span className="pf-label-text">{lang?.category || "Medical Subspecialty"}</span>
              </div>
              <select
                className="pf-select"
                value={formData.category}
                onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                style={{ color: formData.category === "" ? "#94A3B8" : "#0B132B" }}
              >
                <option value="" style={{ color: "#94A3B8" }}>
                  {lang?.case_study_category || "Select medical field"}
                </option>
                {sub_category.map((value) => (
                  <option value={value.id} key={value.id} style={{ color: "#0B132B" }}>
                    {value.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Description Textarea */}
          <div className="pf-field">
            <div className="pf-label">
              <span className="pf-label-text">{lang?.description || "Study Abstract & Clinical Methodology"}</span>
            </div>
            <textarea
              className="pf-textarea"
              rows={3}
              placeholder={lang?.clinical_study_description || "Detail the patient cohort, clinical interventions, statistical methodology, and conclusions..."}
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            />
          </div>

          {/* Supporting material */}
          <section className="pf-study-resources" aria-label="Clinical study supporting material">
            <div className="pf-study-resources-heading">
              <div>
                <span className="pf-study-resources-kicker">Study material</span>
                <h3>Supporting documentation</h3>
              </div>
              <span className="pf-study-resources-note">PDF required</span>
            </div>

            <div className="pf-study-resource-list">
              <div
                className={`pf-study-resource-card pf-study-resource-card-required ${isPdfDragging ? "pf-study-resource-card-dragging" : ""}`}
                {...pdfDropHandlers}
              >
                <div className="pf-study-resource-icon" aria-hidden="true">
                  <FaFilePdf size={18} />
                </div>
                <div className="pf-study-resource-copy">
                  <div className="pf-study-resource-title-row">
                    <span className="pf-study-resource-title">
                      {lang?.attach_complete_clinical_study_pdf || "Complete clinical study"}
                    </span>
                    <span className="pf-study-status-badge">Required</span>
                  </div>
                  <span className="pf-study-resource-description">
                    Attach the final study document as a PDF.
                  </span>
                </div>
                <div className="pf-study-resource-action">
                  <button
                    type="button"
                    className="pf-chip-btn pf-study-resource-btn"
                    onClick={() => document.getElementById('pdfinput').click()}
                  >
                    <FaFilePdf size={13} />
                    <span>{pdf ? (lang?.change_pdf || "Replace PDF") : (lang?.upload_pdf || "Upload PDF")}</span>
                  </button>
                  <input
                    type="file"
                    id="pdfinput"
                    className="d-none"
                    accept=".pdf"
                    onChange={(e) => {
                      const pdfFile = e.target.files[0];
                      if (pdfFile) setPdf(pdfFile);
                    }}
                  />
                </div>
                {pdf && (
                  <div className="pf-file-chip pf-study-file-chip">
                    <FaFilePdf size={16} className="cursor flex-shrink-0" />
                    <span
                      className="pf-file-name"
                      title={pdf.name}
                      onClick={() => {
                        const fileURL = URL.createObjectURL(pdf);
                        window.open(fileURL, "_blank");
                        URL.revokeObjectURL(fileURL);
                      }}
                    >
                      {truncatedName}
                    </span>
                    <span className="pf-study-file-state">PDF attached</span>
                    <button
                      type="button"
                      className="pf-file-remove"
                      aria-label="Remove PDF"
                      onClick={() => setPdf("")}
                    >
                      <IoCloseSharp size={13} />
                    </button>
                  </div>
                )}
              </div>

              <div className="pf-study-resource-card">
                <div className="pf-study-resource-icon" aria-hidden="true">
                  <RiFileList3Line size={19} />
                </div>
                <div className="pf-study-resource-copy">
                  <div className="pf-study-resource-title-row">
                    <span className="pf-study-resource-title">{lang?.add_survey || "Reader survey"}</span>
                    <span className="pf-study-status-badge pf-study-status-badge-optional">Optional</span>
                  </div>
                  <span className="pf-study-resource-description">
                    Add questions to collect feedback from the clinical community.
                  </span>
                </div>
                <div className="pf-study-resource-action">
                  <button
                    type="button"
                    className="pf-chip-btn pf-study-resource-btn"
                    onClick={() => setQsModal(true)}
                  >
                    <RiFileList3Line size={14} />
                    <span>{lang?.add_question || "Add Question"}</span>
                    {surveyQuestionsCount > 0 && (
                      <span className="pf-chip-count">{surveyQuestionsCount}</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* Media Images Dropzone & Thumbnails (shown directly after the description) */}
          <div className="pf-study-media-uploader">
          {(() => {
            const imageList = Array.isArray(imgArr) ? imgArr : Object.values(imgArr || {});
            return imageList.length === 0 ? (
              <div
                className={`pf-media-dropzone ${isImageDragging ? "pf-media-dropzone-active" : ""}`}
                {...imageDropHandlers}
                onClick={handleImageUploadClick}
                role="button"
                tabIndex={0}
              >
                <div className="pf-media-dropzone-inner">
                  <div className="pf-media-dropzone-icon-wrap">
                    <div className="pf-media-dropzone-icon">
                      <RiImageAddLine size={24} />
                    </div>
                  </div>

                  <div className="pf-media-dropzone-text">
                    <div className="pf-media-dropzone-title">
                      {lang?.upload_clinical_case_images || "Upload Clinical Case Images / Scans"}
                    </div>
                    <div className="pf-media-dropzone-desc">
                      {lang?.drag_and_drop_image_browse || "Drag and drop your image here, or browse"}
                    </div>
                    <div className="pf-media-dropzone-hint">
                      Supports high-res JPG, PNG, WEBP (up to 6 photos)
                    </div>
                  </div>

                  <div className="pf-media-dropzone-actions">
                    <button
                      type="button"
                      className="pf-dropzone-action-btn pf-dropzone-btn-primary"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleImageUploadClick();
                      }}
                    >
                      <RiImageAddLine size={15} />
                      <span>{lang?.browse_images || "Browse Images"}</span>
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="pf-card-section">
                <div className="pf-thumb-grid">
                  {imageList.map((img, index) => (
                    <div key={index} className="pf-thumb">
                      <img
                        className="cursor"
                        src={img}
                        onClick={() => handleImageClick(img)}
                        alt="Uploaded"
                      />
                      <button
                        type="button"
                        className="pf-thumb-remove"
                        aria-label="Remove"
                        onClick={() => onImageRemove(index)}
                      >
                        <IoCloseSharp size={14} />
                      </button>
                    </div>
                  ))}

                  {/* Dotted Tile Placeholder in the same grid */}
                  {imageList.length < maxNumber && (
                    <div
                      className="pf-thumb-add-tile"
                      onClick={handleImageUploadClick}
                      role="button"
                      tabIndex={0}
                      aria-label="Add more images"
                    >
                      <div className="pf-thumb-add-tile-icon">
                        <RiUploadCloud2Line size={21} />
                      </div>
                      <span className="pf-thumb-add-tile-count">
                        {imageList.length}/{maxNumber}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            );
          })()}
          </div>
          </div>

          {/* Bottom Actions (Single sticked publish button, cancel removed) */}
          <div className="pf-footer-row">
            <button
              type="submit"
              disabled={!formData.title || !formData.category || !formData.description || !imgArr.length || !pdf}
              className="pf-btn-submit w-100"
            >
              <span>{lang?.publish || "Publish Clinical Study"}</span>
            </button>
          </div>
        </form>

        <Cropper
          images={coverImg}
          setImages={setCoverImg}
          setImagesArr={setImgArr}
          imagesArr={imgArr}
          value={coverImg}
          max={maxNumber}
          allowCrop={true}
          ar={ar}
          setAR={setAR}
          minARatio={minARatio}
          setMaxAR={setMaxAR}
          maxARatio={maxARatio}
          setMinAR={setMinAR}
          resizable={resizable}
          setResizable={setResizable}
          handleClose={handleClose}
          fileUploadRefs={fileUploadRefs}
          setFileUploadRefs={setFileUploadRefs}
          numberOfImages={numberOfImages}
          setNumberOfImages={setNumberOfImages}
          hasSettings={hasSettings}
          setHasSettings={setHasSettings}
          updateCoordinatesCheck={updateCoordinatesCheck}
          setUpdateCoordinatesCheck={setUpdateCoordinatesCheck}
          height={height}
          setHeight={setHeight}
          width={width}
          setWidth={setWidth}
          top={top}
          setTop={setTop}
          left={left}
          setLeft={setLeft}
          cropperOpen={cropperOpen}
          setCropperOpen={setCropperOpen}
        />
      </div>

      <PostImageModal
        ref={childRef}
        type={type}
        getVideoSource={null}
        getImagesUrl={getImagesUrl}
        showModal={showImageModal}
        setShowModal={setShowImageModal}
      />

      {/* Survey Questions Modal */}
      <Modal
        isOpen={qsModal}
        toggle={() => {
          setQsModal(false);
          releaseAgendaScrollLock(true);
        }}
        centered
        scrollable
        className="pf-modal pf-scope-study"
      >
        <div className="pf-modal-header-wrapper">
          <h6 className="fs-15 fw-600 mb-0" style={{ color: "#0B132B" }}>
            {lang?.add_question || "Build Survey Questions"}
          </h6>
          <button
            type="button"
            className="pf-modal-close-btn"
            onClick={() => {
              setQsModal(false);
              releaseAgendaScrollLock(true);
            }}
            aria-label="Close"
          >
            <IoCloseSharp size={18} />
          </button>
        </div>

        <ModalBody className="pf-modal-body">
          {qs.map((value, index) => (
            <div
              key={index}
              className="pf-card-section mb-3"
            >
              <div className="d-flex gap-2 align-items-center mb-2">
                <span
                  style={{
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    background: "var(--pf-accent-light)",
                    color: "var(--pf-accent-dark)",
                    fontSize: "11px",
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {index + 1}
                </span>
                <input
                  type="text"
                  className="pf-input"
                  placeholder={lang?.write_question_here || "Write clinical survey question..."}
                  value={value.question}
                  onChange={(e) => {
                    const updatedQuestionsData = [...qs];
                    updatedQuestionsData[index] = {
                      question: e.target.value,
                      answers: qs[index].answers,
                    };
                    setQs(updatedQuestionsData);
                  }}
                />
              </div>

              <div className="d-flex flex-column gap-2 ps-4 mt-2">
                {value.answers.map((data, id) => (
                  <input
                    key={id}
                    type="text"
                    className="pf-input"
                    placeholder={`${lang?.write_option_here || "Option"} ${id + 1}`}
                    value={data}
                    onChange={(e) => {
                      const updatedQuestionsData = [...qs];
                      updatedQuestionsData[index].answers[id] = e.target.value;
                      setQs(updatedQuestionsData);
                    }}
                  />
                ))}
              </div>
            </div>
          ))}

          <div className="text-end mt-2">
            <button
              type="button"
              className="pf-chip-btn"
              onClick={() => {
                let disable = false;
                qs.forEach((value) => {
                  if (value.question === "") {
                    disable = true;
                    toast.error(lang?.enter_question_please || "Please enter a question.");
                  }
                  value.answers.forEach((data) => {
                    if (data === "") {
                      disable = true;
                      toast.error(lang?.enter_option_please || "Please enter all options.");
                    }
                  });
                });
                if (!disable) {
                  setSavedQs([...qs]);
                  const newQuestion = { question: "", answers: ["", "", ""] };
                  const updatedQuestionsData = [...qs];
                  updatedQuestionsData.push(newQuestion);
                  setQs(updatedQuestionsData);
                }
              }}
            >
              <FaPlus size={10} color="#10B981" /> {lang?.add_question || "Add Another Question"}
            </button>
          </div>
        </ModalBody>

        <ModalFooter
          className="pf-footer-row"
          style={{
            borderTop: "1px solid #EEF2F6",
            padding: "14px 22px",
            margin: 0,
            background: "#FFFFFF",
          }}
        >
          <div className="d-flex w-100 gap-2">
            <button
              type="button"
              className="pf-btn-cancel w-100"
              onClick={() => {
                setQsModal(false);
                releaseAgendaScrollLock(true);
              }}
            >
              {lang?.cancel || "Cancel"}
            </button>
            <button
              type="button"
              className="pf-btn-submit w-100"
              onClick={() => {
                setQsModal(false);
                releaseAgendaScrollLock(true);
              }}
            >
              {lang?.save || "Save Survey"}
            </button>
          </div>
        </ModalFooter>
      </Modal>

      <ImagePreviewModal
        isOpen={isImagePreviewOpen}
        toggle={toggleImagePreview}
        imageSrc={previewImage}
        alt="Clinical Study Preview"
        zIndex={10060}
      />
    </>
  );
}

export default ClinicalStudyTab;
